import React from "react";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { cn } from "@/lib/utils";
import { Loader } from "lucide-react";
function CategoriesMasonry() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div data-section-id="32100" className="flex h-96 w-full items-center justify-center">
        <Loader className="text-primary h-8 w-8 animate-spin" />
      </div>;
  }
  if (error) {
    return <div className="flex h-96 w-full items-center justify-center text-destructive">
        Kunde inte ladda äventyrskategorier.
      </div>;
  }
  if (!terms || terms.length === 0) {
    return null;
  }
  const displayTerms = terms.slice(0, 3);
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
      {displayTerms.map((term, i) => {
      const ratio = i % 2 === 0 ? 4 / 5 : 1;
      return <div key={term.id} data-index={i} className={cn("group relative overflow-hidden rounded-lg shadow-sm transition-all duration-500 hover:shadow-xl")}>
            <Link to={term.link || "#"} className="block h-full w-full">
              <AspectRatio ratio={ratio} className="h-full w-full bg-muted">
                {term.image_url ? <img src={term.image_url} alt={term.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted text-muted-foreground">
                    <span className="text-sm font-sans">Bild saknas</span>
                  </div>}
                
                {}
                <div className="absolute inset-0 bg-primary/40 transition-colors duration-500 group-hover:bg-primary/60" />
                
                {}
                <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center">
                  <h3 className="font-sans text-3xl font-bold text-white tracking-tight opacity-95 transition-opacity duration-300 group-hover:opacity-100 md:text-4xl">
                    {term.name}
                  </h3>
                  <span className="mt-4 inline-block h-1 w-0 bg-accent transition-all duration-500 group-hover:w-16" />
                </div>
              </AspectRatio>
            </Link>
          </div>;
    })}
    </div>;
}
export default function UtforskaKategorier() {
  const wp_term_query_params = {
    taxonomy: "product_cat",
    per_page: 3,
    orderby: "count",
    order: "desc"
  };
  const wp_term_query = new WP_Term_Query(wp_term_query_params);
  return <section id="utforska-kategorier" className="bg-background py-20 md:py-28">
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center">
          <h2 className="font-sans text-4xl font-bold text-primary md:text-5xl">
            Välj Ditt Nästa Äventyr
          </h2>
          <p className="text-muted-foreground mx-auto mt-4 max-w-2xl text-lg font-sans">
            Upptäck våra noga kurerade guider för vandring och cykling genom Europas vackraste landskap.
          </p>
        </div>

        <EcommerceTermsProvider wp_term_query={wp_term_query}>
          <CategoriesMasonry />
        </EcommerceTermsProvider>
      </div>
    </section>;
}